import { render } from "./FinanceTab.vue?vue&type=template&id=064b7284&scoped=true"
import script from "./FinanceTab.vue?vue&type=script&lang=js"
export * from "./FinanceTab.vue?vue&type=script&lang=js"

import "./FinanceTab.vue?vue&type=style&index=0&id=064b7284&scoped=true&lang=css"

import exportComponent from "/home/misha/Рабочий стол/kolos-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-064b7284"]])

export default __exports__